import Enumerator from '../global/Enumerator';

export const jobProgressTypes = ['to_do', 'doing', 'done'];

export class JobProgressType extends Enumerator {
  static default() {
    return this.of('to_do');
  }
}
JobProgressType.initEnum(jobProgressTypes);

export default {
  jobProgressTypes,
  JobProgressType
};
